import React, { useEffect, useState } from "react";
import { DataGrid, gridClasses, GridMoreVertIcon } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { RxPlus } from "react-icons/rx";
import { CiEdit } from "react-icons/ci";
import Button from "@mui/material/Button";
import { IconButton, Popover, MenuItem } from "@mui/material";
import AddEditMotherPlant from "../../components/MotherPlant/AddEditMotherPlant";
import DeleteModal from "../../components/Model/DeleteModal";
import { HttpService } from "../../service/HttpService";
import FullScreenLoader from "../../components/Loader/FullScreenLoader";
import { TbFilterEdit } from "react-icons/tb";
import DateTimeModal from "../Schedule/ScheduleListAdd/DateTimeModal";

const MotherPlant = () => {
  const dateFilterData = JSON.parse(
    localStorage.getItem("motherPlantDateFilter")
  );
  const [open, setOpen] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [motherPlants, setMotherPlants] = useState([]);
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(15);
  const [rowCount, setRowCount] = useState(0);
  const [page, setPage] = useState(0);
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [dataId, setDataId] = useState();
  const [searchData, setSearchData] = useState([]);
  const [openDateModal, setOpenDateModal] = useState(false);
  const [startDate, setStartDate] = useState(
    dateFilterData?.startDate || dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    dateFilterData?.endDate || dayjs().endOf("month").format("YYYY-MM-DD")
  );
  const [selectedRadio, setSelectedRadio] = useState(
    dateFilterData?.selectedRadio || "month"
  );

  const fetchMotherPlant = async () => {
    setLoading(true);
    try {
      const httpService = new HttpService();
      const res = await httpService.get(
        `motherplant/get_plant_mother?page=${
          page + 1
        }&pageSize=${pageSize}&start_date=${startDate}&end_date=${endDate}`
      );

      if (res?.data) {
        setMotherPlants(res?.data?.data || []);
      } else {
        setMotherPlants([]);
      }
      setRowCount(Number(res?.data?.pagination?.total) || 0);
    } catch (e) {
      setMotherPlants([]);
      setRowCount(0);
    }
    setLoading(false);
  };

  useEffect(() => {
    const dateFilterData = JSON.parse(
      localStorage.getItem("motherPlantDateFilter")
    );
    if (dateFilterData) {
      setStartDate(dateFilterData?.startDate);
      setEndDate(dateFilterData?.endDate);
      setSelectedRadio(dateFilterData?.selectedRadio);
    } else {
      const motherPlantDateFilter = {
        startDate: dayjs().startOf("month").format("YYYY-MM-DD"),
        endDate: dayjs().endOf("month").format("YYYY-MM-DD"),
        selectedRadio: "month",
      };
      localStorage.setItem(
        "motherPlantDateFilter",
        JSON.stringify(motherPlantDateFilter)
      );
    }
    fetchMotherPlant();
  }, [page, pageSize, searchData]);

  const handleOpen = () => {
    setOpen(true);
    setIsAdd(true);
    setEditData({});
  };
  const handleClose = () => {
    setOpen(false);
    setIsAdd(false);
    setEditData({});
    fetchMotherPlant();
  };
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleDateTimeModal = () => {
    setOpenDateModal(false);
  };

  const handleOpenDateTimeModal = () => {
    setOpenDateModal(true);
  };
  const handleDelete = async () => {
    try {
      const httpService = new HttpService();
      await httpService.delete(`motherplant/delete_plant_mother/${deleteId}`);
      setOpenDelete(false);
      setDeleteId(null);
      fetchMotherPlant();
    } catch (e) {
      setOpenDelete(false);
      setDeleteId(null);
    }
  };

  const formatLabel = (text) => {
    if (!text) return "";
    return text
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const columns = [
    {
      field: "action",
      headerName: "Actions",
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      sortable: false,
      width: 100,
      renderCell: (params) => (
        <>
          <div className="action_icon-weap">
            <IconButton
              onClick={(e) => {
                handleMenuClick(e);
                setDataId(params.row.id);
                setEditData(params.row);
              }}
            >
              <GridMoreVertIcon />
            </IconButton>
          </div>
          {anchorEl && dataId === params?.row?.id && (
            <Popover
              className="popup-menu"
              key={dataId}
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={handleCloseMenu}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem
                onClick={() => {
                  setOpen(true);
                  setIsAdd(false);
                  handleCloseMenu();
                }}
                className="menu-list-items"
              >
                <div className="menu-list-items-text">Edit</div>
              </MenuItem>
              {/* <MenuItem
                onClick={() => {
                  setOpenDelete(true);
                  setDeleteId(params.row.id);
                  handleCloseMenu();
                }}
                className="menu-list-items"
              >
                <div className="menu-list-items-text">Delete</div>
              </MenuItem> */}
            </Popover>
          )}
        </>
      ),
    },
    { field: "plant_name", headerName: "Cultivar", flex: 1, minWidth: 130 },
    { field: "matric_id", headerName: "MATRIC ID", flex: 1, minWidth: 150 },
    {
      field: "date",
      headerName: "Date",
      flex: 1,
      minWidth: 130,
      renderCell: (params) =>
        params.row?.date ? dayjs(params.row.date).format("MM-DD-YYYY") : "-",
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 130,
      renderCell: (params) => (params.value ? formatLabel(params.value) : ""),
    },
  ];

  return (
    <>
      {loading && <FullScreenLoader />}
      <div className="motherplant">
        <div className="page-title">
          <div className="title-wrap">
            <h1>MotherPlant</h1>
          </div>
          <div className="button-wrap">
            <button
              type="submit"
              className="btn btn-primary"
              onClick={handleOpen}
            >
              <RxPlus /> Add MotherPlant
            </button>
          </div>
        </div>
        <div className="table-filter-wrap d-flex justify-content-between pb-0">
          <div className="header_search-wrap">
            {/* <div className="header_search_bar common_content d-flex">
              <div className="input-group input_group">
                <button className="btn search-btn search_btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 21 21"
                    fill="none"
                  >
                    <circle
                      cx="9.98856"
                      cy="9.98856"
                      r="8.98856"
                      stroke="#495057"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16.2402 16.7071L19.7643 20.222"
                      stroke="#495057"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <input
                  type="search"
                  className="form-control form_control"
                  placeholder="Search..."
                  aria-label="Search"
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchData(value);
                  }}
                />
              </div>
            </div> */}
          </div>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => handleOpenDateTimeModal()}
            className="filters-btn"
            style={{ textTransform: "none" }}
          >
            <TbFilterEdit /> Filters
          </Button>
        </div>
        <div
          style={{
            height: `${motherPlants?.length > 0 ? "" : "200px"}`,
            width: "100%",
            marginTop: 24,
          }}
        >
          <DataGrid
            rows={motherPlants}
            columns={columns}
            loading={loading}
            rowCount={rowCount}
            pageSizeOptions={[15, 50, 100]}
            paginationModel={{ pageSize, page }}
            paginationMode="server"
            onPaginationModelChange={({ page, pageSize }) => {
              setPage(page);
              setPageSize(pageSize);
            }}
            getRowHeight={() => "auto"}
            sx={{
              border: "1px solid #E0E0E0",
              [`& .${gridClasses.cell}`]: { py: 0.5 },
            }}
            autoHeight
            showCellVerticalBorder
            showColumnVerticalBorder
          />
        </div>
        <AddEditMotherPlant
          open={open}
          isAdd={isAdd}
          handleClose={handleClose}
          rows={editData}
          fetchMotherPlant={fetchMotherPlant}
        />
        <DeleteModal
          open={openDelete}
          HandleClose={() => setOpenDelete(false)}
          HandleDelete={handleDelete}
        />
        {openDateModal && (
          <DateTimeModal
            handleDateTimeModal={() => handleDateTimeModal()}
            setStartDate={(e) => setStartDate(e)}
            setEndDate={(e) => setEndDate(e)}
            open={openDateModal}
            fetchSchedule={() => {
              fetchMotherPlant();
              const motherPlantDateFilter = {
                startDate: startDate,
                endDate: endDate,
                selectedRadio: selectedRadio,
              };
              localStorage.setItem(
                "motherPlantDateFilter",
                JSON.stringify(motherPlantDateFilter)
              );
            }}
            selectedRadio={selectedRadio}
            setSelectedRadio={(e) => setSelectedRadio(e)}
            startDate={startDate}
            endDate={endDate}
          />
        )}
      </div>
    </>
  );
};

export default MotherPlant;
